// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.elixir-amount {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  font-size: 9.5px;
  font-weight: 700;
  color: rgba(74, 222, 128, 0.85);
  letter-spacing: 0.04em;
  font-variant-numeric: tabular-nums;
  flex-shrink: 0;
}

/* Inline variant — blends bolt+number into surrounding text (inherits size/weight). */
.elixir-amount--inline {
  font-size: inherit;
  font-weight: inherit;
  gap: 3px;
  letter-spacing: 0;
}
`, "",{"version":3,"sources":["webpack://./src/components/ElixirAmount.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;EAChB,+BAA+B;EAC/B,sBAAsB;EACtB,kCAAkC;EAClC,cAAc;AAChB;;AAEA,sFAAsF;AACtF;EACE,kBAAkB;EAClB,oBAAoB;EACpB,QAAQ;EACR,iBAAiB;AACnB","sourcesContent":[".elixir-amount {\n  display: inline-flex;\n  align-items: center;\n  gap: 2px;\n  font-size: 9.5px;\n  font-weight: 700;\n  color: rgba(74, 222, 128, 0.85);\n  letter-spacing: 0.04em;\n  font-variant-numeric: tabular-nums;\n  flex-shrink: 0;\n}\n\n/* Inline variant — blends bolt+number into surrounding text (inherits size/weight). */\n.elixir-amount--inline {\n  font-size: inherit;\n  font-weight: inherit;\n  gap: 3px;\n  letter-spacing: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
